// extracted by mini-css-extract-plugin
export default {"translations-header":"web-translation_translations-header__Unzmx"};